import slugify from "@sindresorhus/slugify";
import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { countries, getEmojiFlag, TCountryCode, continents, TContinentCode } from "countries-list";

export { slugify, clsx as cx };

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function normalizeText(input: string): string {
  // Replace multiple spaces with a single space
  let normalized = input.replace(/\s+/g, " ");
  // Replace multiple line breaks with a single line break
  normalized = normalized.replace(/\n+/g, "\n");
  // Trim leading/trailing whitespace
  return normalized.trim();
}

export const getURL = (path: string = "") => {
  // Check if NEXT_PUBLIC_SITE_URL is set and non-empty. Set this to your site URL in production env.
  let url =
    process?.env?.NEXT_PUBLIC_SITE_URL && process.env.NEXT_PUBLIC_SITE_URL.trim() !== ""
      ? process.env.NEXT_PUBLIC_SITE_URL
      : // If not set, check for NEXT_PUBLIC_VERCEL_URL, which is automatically set by Vercel.
        process?.env?.NEXT_PUBLIC_VERCEL_URL && process.env.NEXT_PUBLIC_VERCEL_URL.trim() !== ""
        ? process.env.NEXT_PUBLIC_VERCEL_URL
        : // If neither is set, default to localhost for local development.
          "http://localhost:3000/";

  // Trim the URL and remove trailing slash if exists.
  url = url.replace(/\/+$/, "");
  // Make sure to include `https://` when not localhost.
  url = url.includes("http") ? url : `https://${url}`;
  // Ensure path starts without a slash to avoid double slashes in the final URL.
  path = path.replace(/^\/+/, "");

  // Concatenate the URL and the path.
  return path ? `${url}/${path}` : url;
};

export function getCountryLabel(key: TCountryCode) {
  const countryName = countries[key]?.name;
  return `${getEmojiFlag(key) ?? ""} ${countryName}`;
}

const regions = [
  {
    label: "🌍 Africa",
    value: "Africa",
  },
  {
    label: "🌏 Asia",
    value: "Asia",
  },
  {
    label: "🌍 Europe",
    value: "Europe",
  },
  {
    label: "🕌 Middle East",
    value: "Middle East",
  },
  {
    label: "🌎 North America",
    value: "North America",
  },
  {
    label: "🌏 Oceania",
    value: "Oceania",
  },
  {
    label: "🌎 South America",
    value: "South America",
  },
];

interface IRegionAndCountry {
  value: string;
  label: string;
  disable?: boolean;
}

export const remoteLabel = { label: "🌍 Remote", value: "Remote" };
export const regionsAndCountries: Array<IRegionAndCountry> = [
  remoteLabel,
  { label: "Regions", value: "regions", disable: true },
  ...regions,
  { label: "──────────", value: "---", disable: true },
  { label: "Countries", value: "countries", disable: true },
  ...Object.keys(countries).map((key: string) => {
    return {
      value: countries[key as TCountryCode]?.name,
      label: getCountryLabel(key as TCountryCode),
    };
  }),
];

export function transformString(input: string): string {
  // Remove 't-' prefix if it exists
  if (!input) return input;

  if (input.startsWith("t-")) {
    input = input.substring(2);
    return input.substring(0, input.length - 4);
  }
  return input;
}
